import { compiler } from "markdown-to-jsx";

export const Legacy_CompileMarkdown = (content: string) => {
  return compiler(content.trim() + '\n\n', {
    forceWrapper: true,
    wrapper: 'div',
    overrides: {
      span: 'p',
    },
    disableParsingRawHTML: true
  });
};

export const CompileMarkdown = (content: string) => {
  return compiler(content.trim(), {
    forceBlock: true
  })
};